import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUserId, logout } from '../utils/session';
import { isAdmin } from '../config/learners';
import { clearAllProgress } from '../utils/exerciseProgress';
import { logEvent } from '../utils/experimentLog';

// Home の右上に出す「あなたの番号」。
// この方式は認証ではなく識別なので、他人の番号で入ってしまうことは起こりうる。
// 番号を常に見えるところに出し、その場で選び直せるようにして取り違えに気づかせる。
// ログアウト時はその番号の進行状態を消す：1日の実験で同じ番号を別の学習者が
// 使い回すため、次にその番号で入る人が前の人の続きから始まらないようにする。
function LearnerBadge() {
  const navigate = useNavigate();
  const userId = getCurrentUserId();
  const [confirming, setConfirming] = useState(false);

  const handleLogout = () => {
    // ログアウト記録は logout の前に送る（ログに番号を載せるため）
    logEvent('logout');
    clearAllProgress(userId);
    logout();
    navigate('/login');
  };

  if (userId == null) {
    return (
      <div className="learner-badge">
        <span className="learner-badge__label">番号を選んでいません</span>
        <button type="button" className="btn-sheet" onClick={() => navigate('/login')}>
          ログイン
        </button>
      </div>
    );
  }

  return (
    <div className="learner-badge">
      <span className="learner-badge__label">{isAdmin(userId) ? '管理者' : 'あなたの番号'}</span>
      <span className="learner-badge__number">{userId}</span>
      {confirming ? (
        <div className="learner-badge__confirm">
          <p className="learner-badge__confirm-text">
            番号がちがう場合は選び直してください。いまの番号の進み具合は消え、次は問1から始まります。
          </p>
          <div className="learner-badge__confirm-row">
            <button type="button" className="btn-sheet" onClick={handleLogout}>
              選び直す
            </button>
            <button type="button" className="btn-sheet btn-sheet--quiet" onClick={() => setConfirming(false)}>
              やめる
            </button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          className="btn-sheet btn-sheet--quiet"
          onClick={() => setConfirming(true)}
          title="ログアウトして番号を選び直す"
        >
          番号を変える
        </button>
      )}
    </div>
  );
}

export default LearnerBadge;
